import store from '@/store/store';

export const isAlreadyBought = (productId) => {
  const traits = store.getters.getTraits;
  const boughtProducts = store.getters.getBoughtProducts;
  let response = false;
  if(traits && boughtProducts) {
    let found = boughtProducts.findIndex((item) => item == productId);
    response = found !== -1;
  }
  return response;
}

export const isAvailableInCommerce = (productCommerceId) => {
  let response = false;
  const city = store.getters.getCity;
  if(city && city.id && productCommerceId) {
    return city.id === productCommerceId;
  }
  return response;
}